import * as z from "zod";
//#region src/__generated__/auth/user/zod/groupDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const groupDtoSchema = z.object({
	attributes: z.object({}).catchall(z.array(z.string())).nullish(),
	id: z.uuid().nullish(),
	name: z.string().nullish()
});
//#endregion
//#region src/__generated__/auth/user/zod/userDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const userDtoSchema = z.object({
	attributes: z.object({}).catchall(z.array(z.string())).nullish(),
	email: z.string().nullish(),
	enabled: z.boolean().nullish(),
	firstName: z.string().nullish(),
	groups: z.array(groupDtoSchema).nullish(),
	id: z.uuid().nullish(),
	lastName: z.string().nullish(),
	middleName: z.string().nullish(),
	passwordValidTo: z.string().nullish(),
	phone: z.string().nullish(),
	position: z.string().nullish(),
	realmRoles: z.array(z.string()).nullish(),
	userValidTo: z.string().nullish()
});
//#endregion
//#region src/__generated__/auth/user/zod/getCurrentUserInfoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getCurrentUserInfoStatus200Schema = userDtoSchema.omit({ attributes: true });
const getCurrentUserInfoResponseSchema = getCurrentUserInfoStatus200Schema;
//#endregion
//#region src/__generated__/auth/user/zod/getUserInfoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getUserInfoPathUserIdSchema = z.uuid();
const getUserInfoStatus200Schema = userDtoSchema.omit({ attributes: true });
const getUserInfoResponseSchema = getUserInfoStatus200Schema;
//#endregion
//#region src/__generated__/auth/user/zod/getUserListByIdSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getUserListByIdQueryUserIdsSchema = z.array(z.uuid());
const getUserListByIdStatus200Schema = z.array(userDtoSchema);
const getUserListByIdResponseSchema = getUserListByIdStatus200Schema;
//#endregion
//#region src/__generated__/auth/user/zod/getUserListById1Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getUserListById1QueryUserIdsSchema = z.array(z.uuid());
const getUserListById1Status200Schema = z.array(userDtoSchema);
const getUserListById1ResponseSchema = getUserListById1Status200Schema;
//#endregion
//#region src/__generated__/auth/user/zod/getUserListByIdFromPostSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getUserListByIdFromPostStatus200Schema = z.array(userDtoSchema);
const getUserListByIdFromPostResponseSchema = getUserListByIdFromPostStatus200Schema;
const getUserListByIdFromPostDataSchema = z.array(z.uuid());
//#endregion
//#region src/__generated__/auth/user/zod/getUsersSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getUsersStatus200Schema = z.array(userDtoSchema);
const getUsersResponseSchema = getUsersStatus200Schema;
//#endregion
//#region src/__generated__/auth/user/zod/getUsersPaginatedSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getUsersPaginatedQueryParamSchema = z.string().optional().describe("Отвечает за выборку по Ф, И или О. При необходимости получения последовательно всего списка пользователей параметр следует игнорировать.");
const getUsersPaginatedQueryFirstSchema = z.string().optional().describe("Позиция начала результатов выборки.");
const getUsersPaginatedQueryMaxSchema = z.string().optional().describe("Общее колличество возвращаемых данных из выборки.");
const getUsersPaginatedStatus200Schema = z.array(userDtoSchema);
const getUsersPaginatedResponseSchema = getUsersPaginatedStatus200Schema;
//#endregion
export { groupDtoSchema as C, userDtoSchema as S, getUserInfoPathUserIdSchema as _, getUsersPaginatedStatus200Schema as a, getCurrentUserInfoResponseSchema as b, getUserListByIdFromPostDataSchema as c, getUserListById1QueryUserIdsSchema as d, getUserListById1ResponseSchema as f, getUserListByIdStatus200Schema as g, getUserListByIdResponseSchema as h, getUsersPaginatedResponseSchema as i, getUserListByIdFromPostResponseSchema as l, getUserListByIdQueryUserIdsSchema as m, getUsersPaginatedQueryMaxSchema as n, getUsersResponseSchema as o, getUserListById1Status200Schema as p, getUsersPaginatedQueryParamSchema as r, getUsersStatus200Schema as s, getUsersPaginatedQueryFirstSchema as t, getUserListByIdFromPostStatus200Schema as u, getUserInfoResponseSchema as v, getCurrentUserInfoStatus200Schema as x, getUserInfoStatus200Schema as y };

//# sourceMappingURL=getUsersPaginatedSchema.js.map